import { Endpoints } from "constants/endpoints";
import type { InformationRuc } from "models";
import { rucApiClient } from "./apiClients";

/**
 * Récupère les informations RUC d'une commune
 * @param communeId Code INSEE de la commune
 * @returns une InformationRuc ou une erreur en cas d'absence
 */
async function getByCommuneId(communeId: string): Promise<InformationRuc> {
  const url = `/${Endpoints.INFOS_RUC}/${communeId}`;
  return rucApiClient.get(url);
}

async function uploadNewRucExcel(formData: FormData): Promise<void> {
  const url = Endpoints.INFOS_RUC;
  return rucApiClient.post(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export const informationsRucService = {
  getByCommuneId,
  uploadNewRucExcel,
};
